import React from "react";
import Rating from "./Rating";

const ListItem = (props) => {
  const { item } = props;
  const featuredUrl = item.featured_image?.image_url || "";

  return (
    <div className="col-lg-12 col-md-12">
      <div className="utf_listing_item-container list-layout">
        <a
          href={`/listing/${item.slug}`}
          className="utf_listing_item"
          data-marker-id={`${item.id}`}
          target="_blank"  
          data-name={item.name}
          data-address={item.full_address}
          data-image={featuredUrl}
          data-lat="7.8906229"
          data-lng="98.2964358"
          data-url={`/listing/${item.slug}`}
          data-marker-url="https://swanpass.com/wp-content/uploads/2023/02/pin-normal-soapy.png"
          data-distance=""
          data-selected-marker-url="https://swanpass.com/wp-content/uploads/2023/02/pin-selected-soapy.png"
        >
          <div className="utf_listing_item-image">
            <img
              alt={item.name}
              className="lazyload"
              loading="lazy"
              width="373"
              height="250"
              src={featuredUrl}
            />
            <span
              className={`like-icon ${item.favorited ? 'liked' : ''}`}
              data-remote-url={`/listing/${item.slug}/favorite`}
            ></span>
            <div className="utf_listing_prige_block utf_half_list">
              <div className="listing-cats">
                {item.categories && item.categories.map((cat) => (
                  <span key={`cat-${cat}`} className="listing-cat-name">{cat}</span>
                ))}
              </div>
            </div>
          </div>
          <div className="utf_listing_item_content">
            <div className="utf_listing_item-inner">
              <h3>
                {item.name}
                <i className="utf_approve_listing"></i>
              </h3>
              <span>
                <i className="fa fa-map-pin"></i>
                {item.full_address}
              </span>
              {
                item.phone &&  <span>
                <i className="fa fa-phone"></i> {item.phone}
              </span>

              }
             
              <div className="utf_star_rating_section" data-rating={Math.round(+item.avg_rating * 10)/10}>
                <Rating value={item.avg_rating}/>     
                <div className="utf_counter_star_rating">({item.views_count})</div>
       
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
  );
};

export default ListItem;
